import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LimitFlowProposalService } from '../../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';

export interface SendToNextLevelModel {
	accountClientID: string,
	proposalID: string,
  segmentoID: string,
  userPerfil: string,
  nivelAtual: number
}

@Component({
  selector: 'app-redirect-flow-committee-modal',
  templateUrl: './redirect-flow-committee-modal.component.html',
  styleUrls: ['./redirect-flow-committee-modal.component.scss']
})
export class RedirectFlowCommitteeModalComponent extends DialogComponent<SendToNextLevelModel, string> implements SendToNextLevelModel {

	accountClientID: string;
	proposalID: string;
  segmentoID: string;
  userPerfil: string;
  nivelAtual: number;

  nivel: any[] = [];
	niveis: any[] = [];

  constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService) {
    super(dialogService);
  }

  ngOnInit() {
    console.log("this.accountClientID: " + this.accountClientID);
    console.log("this.proposalID: " + this.proposalID);
    console.log("this.segmentoID: " + this.segmentoID);
    console.log("this.userPerfil: " + this.userPerfil);
    console.log("this.nivelAtual: " + this.nivelAtual);

    this.getApprovers();
  }

  sendProposal(obj) {
    console.log(obj);
    this.confirm(obj);
  }

  getApprovers() {
    this.limitFlowProposalService.getApprovers(this.segmentoID, this.nivelAtual).subscribe(result => {
      if (result.Result) {
        if (result.Result.length > 0) {
          for (var fluxo in result.Result) {
            var obj = result.Result[fluxo];
            
            if (!this.userPerfil.includes(obj.PrimeiroPerfil.Descricao)) { // Bypass same profiles
              this.niveis.push({
                ID: obj.ID,
                Descricao: (obj.PrimeiroPerfil != null && obj.SegundoPerfil != null ? `${obj.PrimeiroPerfil.Descricao} + ${obj.SegundoPerfil.Descricao}` : `${obj.PrimeiroPerfil.Descricao}`)
              });
            }
          }
        }
      }
    });
  }

  confirm(obj) {
		this.result = obj.ID;
		this.close();
	}

}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/redirect-flow-committee-modal/redirect-flow-committee-modal/redirect-flow-committee-modal.component.ts